var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKamiLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "610 440 650 210",
    style: {
      enableBackground: "new 610 440 650 210"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ffffff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "880.51,468.12 807.64,613.88 953.39,613.88  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1114.83,613.88 969.08,613.88 969.08,468.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1041.96,541 1114.83,613.88 1114.83,468.12  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "719.06,541 791.94,468.12 646.19,468.12 646.19,613.88 646.19,613.88 719.06,541  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "646.19,613.88 791.94,613.88 728.64,550.57  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1229.03,556.81 1229.03,556.81 1229.03,467.32 1139.53,467.32 1229.03,556.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1139.53,467.32 1139.53,613.88 1229.03,613.88 1229.03,576.47  "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKamiLogo);
export default __webpack_public_path__ + "static/media/kami-logo.1c7770176b95fb18f3e382478c892132.svg";
export { ForwardRef as ReactComponent };